export { default } from '@klokhuis/modules/Commons/pages/Terms/Terms.page';
